module.exports = __webpack_public_path__ + "media/images/cart/cart_btn01_ov-8d896f3b6931047aa1f551020abb3e03.gif";